import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import type { operations } from "@/lib/api/schema";

export async function getCertificationsList(
  params: operations["PersonCertificationController_getPersonCertifications_v2"]["parameters"],
) {
  const res = await apiClient.GET("/v2/people/{personId}/certifications", {
    params,
  });

  return getDataOrThrowApiError(res);
}
